import { multiply } from '@whitelabel/helpers/units';
export default function getStylesBasedOnTotalImages(totalImages: any, theme: any) {
  const styles = {
    alignment: 'space-around',
  };
  if (totalImages >= 5) {
    (styles as any).imageBoxMaxWidth = 100 / 3;
    (styles as any).imageBoxMaxWidthSm = 100 / 3;
    (styles as any).imageBoxMaxWidthMd = 100 / 3;
    (styles as any).imageBoxMaxWidthLg = 100 / totalImages;
    (styles as any).addMarginTopAfter = 3;
    (styles as any).addMarginTopAfterSm = 3;
    (styles as any).addMarginTopAfterMd = 3;
    (styles as any).imageMaxWidthSm = '70%';
    (styles as any).imageMaxWidthMd = '70%';
  } else if (totalImages === 4) {
    (styles as any).imageBoxMaxWidth = 40;
    (styles as any).imageBoxMaxWidthSm = 25;
    (styles as any).imageBoxMaxWidthMd = 25;
    (styles as any).addMarginTopAfter = 2;
  } else {
    (styles as any).imageBoxMaxWidth = 100;
    (styles as any).imageBoxMaxWidthSm = 100 / 3;
    (styles as any).imageBoxMaxWidthMd = 25;
    (styles as any).addMarginTopAfter = 1;
    (styles as any).imageMaxWidth = multiply(theme.spacer, 12.5);
  }
  return styles;
}
